import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router";
import { ErrorPage } from "@/shared/components/ErrorPage";
import { ConsentRoot } from "@/shared/components/consent/ConsentRoot";
import { ToastHost } from "@/shared/components/ui/Toast";
import { queryClient } from "@/shared/lib/queryClient";
import { router } from "@/router";

export function App() {
  return (
    <Sentry.ErrorBoundary
      // Safety net for anything the route errorElement can't reach (the provider
      // tree, the router setup itself). Sentry.ErrorBoundary auto-captures, so no
      // explicit report needed here. "Go back" can't use the router (it may have
      // crashed), so fall back to a hard navigation home.
      fallback={({ resetError }) => (
        <ErrorPage
          onTryAgain={resetError}
          onGoBack={() => {
            window.location.href = "/app";
          }}
        />
      )}
    >
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ToastHost />
        <ConsentRoot />
        {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}
